
import { supabase } from '@/integrations/supabase/client';

/**
 * Creates a Stripe portal session for managing billing
 */
export const createBillingPortalSession = async (
  customerId: string
): Promise<{ url: string } | { error: string }> => {
  try {
    const { data, error } = await supabase.functions.invoke('create-portal-session', {
      body: { 
        customerId,
        returnUrl: `${window.location.origin}/subscriptions`
      }
    });

    if (error) {
      console.error('Error creating portal session:', error);
      return { error: error.message };
    }

    return { url: data.url };
  } catch (err) {
    console.error('Exception creating portal session:', err);
    return { error: err instanceof Error ? err.message : 'Une erreur est survenue' };
  }
};
